// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"fP-z","categoryName":"gP-z","categoryNameSearchHeader":"hP-z","categoryContent":"iP-z","bottomAligned":"jP-z","image":"kP-z","imageNoBackground":"lP-z"};